import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ConfirmationService } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { EntradaEstoque } from 'src/app/admihair/api/dto/entrada-estoque';
import { EntradaEstoqueService } from 'src/app/admihair/service/entrada-estoque.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';


@Component({
  selector: 'app-entrada-listar',
  templateUrl: './entrada-listar.component.html',
  styleUrls: ['./entrada-listar.component.scss']
})
export class EntradaListarComponent extends AdmihairBaseComponent implements OnInit {

  empresaSelecionada?: Empresa;
  listaEntradaEstoque: EntradaEstoque[] = [];
  loadingEntrada: boolean = true;
  @ViewChild('filter') filter!: ElementRef;

  constructor(private entradaEstoqueService: EntradaEstoqueService,
    private confirmationService: ConfirmationService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    utilStorageService: UtilStorageService) {
    super(erroService, utilStorageService)
  }


  ngOnInit(): void {
    this.verificarPermissoes();
    this.empresaSelecionada = this.getEmpresa();
    if (this.permissaoListar) {
      this.listarEntradaEstoque();
    }
  }

  listarEntradaEstoque() {
    this.entradaEstoqueService.listarPorEmpresaId(this.empresaSelecionada?.id).subscribe({
      next: (data: EntradaEstoque[]) => {
        this.listaEntradaEstoque = data;
        this.loadingEntrada = false;
      },
      error: (err: any) => {
        this.loadingEntrada = false;
        this.exibirMensagemErro(err);
      }
    })

  }

  excluirEntrada(id: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.entradaEstoqueService.excluirEntrada(id).subscribe({
          next: () => {
            this.loadingEntrada = true;
            this.exibirMensagemSucesso();
            this.listarEntradaEstoque();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });
      }
    });
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  editarEntrada(id: number) {
    this._router.navigate(["/apps/entrada/editar/" + id], { relativeTo: this._activatedRoute })
  }

  detalharEntrada(id: number) {
    this._router.navigate(["/apps/entrada/detalhar/" + id], { relativeTo: this._activatedRoute })
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_ENTRADA');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_ENTRADA');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_ENTRADA');
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_ENTRADA');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_ENTRADA');
  }
}
